<template>
    <div>
        <div class="container vault-page">
            <div class="d-flex justify-content-between mb-5">
                <div class="view-mode">
                    <div class="view-mode-item" @click="viewMode = 'GRID'">
                        <img
                            :src="
                                viewMode === 'GRID'
                                    ? '/icon/tab-grid-green.svg'
                                    : '/icon/tab-grid.svg'
                            "
                            class="mob-img"
                            alt=""
                        />
                    </div>
                    <div class="view-mode-item" @click="viewMode = 'LIST'">
                        <img
                            :src="
                                viewMode === 'LIST'
                                    ? '/icon/tab-list-green.svg'
                                    : '/icon/tab-list.svg'
                            "
                            class="mob-img"
                            alt=""
                        />
                    </div>
                </div>
                <div class="filter-box" id="filter-wrapper">
                    <div class="dropdown-filter-wrapper">
                        <div class="dropdown my-dropdown mr-2 mb-2 d-flex">
                            <button
                                class="btn dropdown-toggle ml-auto"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                sort by {{ sortText }}
                            </button>
                            <div
                                class="dropdown-menu dropdown-menu-right"
                                aria-labelledby="dropdownMenuButton"
                            >
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="sorting('apy', 'apy', 'desc')"
                                >
                                    APY
                                </a>
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="
                                        sorting(
                                            'newest',
                                            'vault.created_at_timestamp',
                                            'desc'
                                        )
                                    "
                                >
                                    Newest
                                </a>
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="
                                        sorting(
                                            'oldest',
                                            'vault.created_at_timestamp'
                                        )
                                    "
                                >
                                    Oldest
                                </a>
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="
                                        sorting(
                                            'expiry date',
                                            'vault_detail.expiry_timestamp'
                                        )
                                    "
                                >
                                    expiry date
                                </a>
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="
                                        sorting(
                                            'strike price: High to low',
                                            'vault_detail.strike_price',
                                            'desc'
                                        )
                                    "
                                >
                                    strike price: High to low
                                </a>
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="
                                        sorting(
                                            'strike price: low to high',
                                            'vault_detail.strike_price'
                                        )
                                    "
                                >
                                    strike price: low to high
                                </a>
                            </div>
                        </div>
                        <div class="dropdown my-dropdown mr-2 mb-2 d-flex">
                            <button
                                class="btn dropdown-toggle ml-auto"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                {{ tokenText }}
                            </button>
                            <div
                                class="dropdown-menu dropdown-menu-right"
                                aria-labelledby="dropdownMenuButton"
                            >
                                <div>
                                    <a
                                        class="dropdown-item"
                                        href="#"
                                        @click="
                                            filtering(
                                                'vault_token.symbol',
                                                'all tokens'
                                            )
                                        "
                                    >
                                        ALL TOKENS
                                    </a>
                                    <a
                                        v-for="(item, index) in network_tokens"
                                        :key="index"
                                        class="dropdown-item"
                                        href="#"
                                        @click="
                                            filtering(
                                                'vault_token.symbol',
                                                item.symbol
                                            )
                                        "
                                    >
                                        {{ item.symbol.toUpperCase() }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <feature-fault
                        :items="vaults"
                        class="mb-3 flex-wrap feature-fault"
                    /> -->
            <div class="fault-cont" v-show="viewMode === 'LIST'">
                <div v-for="(item, index) in allVaults" :key="index">
                    <item-vault :item="item" :key="Math.random()" />
                </div>
            </div>
            <div
                v-show="viewMode !== 'LIST'"
                class="row justify-content-center"
            >
                <div
                    class="col-12 col-md-4 mb-5"
                    v-for="(vault, index) in allVaults"
                    :key="index"
                >
                    <vault-block :data="vault" :key="Math.random()" />
                </div>
            </div>

            <!-- <div class="mb-5" v-for="(d, index) in data" :key="index">
                <div class="title text-capitalize">
                    {{ d.categoryName }} ({{ d.vaults.length }})
                </div>
                <template v-if="viewMode === 'GRID'">
                    <div class="row justify-content-center">
                        <div
                            class="col-12 col-md-4 mb-5"
                            v-for="(vault, index) in d.vaults"
                            :key="index"
                        >
                            <vault-block :data="vault" />
                        </div>
                    </div>
                </template>
                <template v-if="viewMode === 'LIST'">
                    <feature-fault
                        :items="d.vaults"
                        class="mb-3 flex-wrap feature-fault"
                    />
                </template>
            </div> -->
        </div>

        <!-- Remove the leave bg -->
        <!-- <div class="top-wave"></div>
        <div class="bottom-leafs"></div> -->
    </div>
</template>

<script>
import VaultBlock from "../components/VaultBlock";
import featureFault from "../components/featureFault.vue";
import ItemVault from "../components/ItemVault.vue";

import { mapActions, mapState, mapGetters } from "vuex";

import Web3 from "web3";

export default {
    components: { VaultBlock, featureFault, Web3, ItemVault },
    data() {
        return {
            viewMode: "GRID",
            categories: ["deposited vaults", "available vaults"],
            allVaults: [],
            defaultVaults: [],
            sortText: null,
            activeSort: {
                name: "apy",
                key: "apy",
                sort: "desc"
            },
            tokenText: "all tokens",
            tokens: []
        };
    },
    computed: {
        ...mapGetters({
            chainId: "wallet/getChainId",
            hasWallet: "wallet/getHasWallet",
            walletProvider: "wallet/getWalletProvider"
        }),
        ...mapState(["vaults"]),
        network_tokens() {
            const filteredTokens = [];

            for (let i = 0; i < this.tokens.length; i++) {
                const token = this.tokens[i];
                for (let j = 0; j < this.defaultVaults.length; j++) {
                    const vault = this.defaultVaults[j];

                    if (token.symbol == vault.token) {
                        //prevent duplicate token, only stored 1 unique token
                        if (
                            !filteredTokens.find(
                                a =>
                                    a.symbol == vault.token &&
                                    a.network == vault.network
                            )
                        ) {
                            filteredTokens.push(token);
                        }
                    }
                }
            }
            if (this.chainId && this.walletProvider && this.hasWallet) {
                let chainId = this.chainId;
                if (chainId == 0) {
                    chainId = "0x1";
                }
                return filteredTokens.filter(
                    a => a.network == this.getTokenNetwork(chainId)
                );
            } else return filteredTokens;
        }
    },
    watch: {
        chainId(newChainId, oldChainId) {
            if (!this.walletProvider || !this.hasWallet) return;
            this.getAllVaults(newChainId).then(result => {
                setTimeout(() => {
                    this.sorting("apy", "apy", "desc");
                }, 1000);
            });
        },
        hasWallet(v) {
            let chainId = this.chainId;
            if (!v) chainId = "all";
            this.getAllVaults(chainId).then(result => {
                setTimeout(() => {
                    this.sorting("apy", "apy", "desc");
                }, 1000);
            });
        },
        "$store.state.vaults.vaults": {
            handler: function(nv) {
                this.allVaults = nv;
                this.defaultVaults = nv;
                //
            }
            //immediate: true // provides initial (not changed yet) state
        }
    },
    methods: {
        getTokenNetwork(key) {
            const arrayKey = this.$store.state.vaults.env.network;

            let tokenId = null;
            for (const key2 in arrayKey) {
                const element = arrayKey[key2];
                if (element.chain == key) tokenId = key2;
            }

            return tokenId;
        },
        async initToken() {
            await this.$store
                .dispatch("API", {
                    method: "get",
                    url: "/api/admin/options"
                })
                .then(result => {
                    this.tokens = result.token;
                });
        },
        ...mapActions({
            getAllVaults: "vaults/getAllVaults"
            // connectWithMetamask: "wallet/connectWithMetamask"
        }),
        sorting(name, key, sort = "asc") {
            this.activeSort = {
                name: name,
                key: key,
                sort: sort
            };
            if (sort == "asc")
                this.allVaults.sort(
                    (a, b) => this.fetchKey(key, a) - this.fetchKey(key, b)
                );
            else {
                this.allVaults.sort(
                    (a, b) => this.fetchKey(key, b) - this.fetchKey(key, a)
                );
            }
            this.sortText = name;
        },
        fetchKey(key, item) {
            if (key.includes(".")) {
                const arrayKey = key.split(".");
                let value = null;
                for (let i = 0; i < arrayKey.length; i++) {
                    const element = arrayKey[i];
                    if (value) value = value[element];
                    else value = item[element];
                }

                return value;
            } else {
                return item[key];
            }
        },
        filtering(key, value) {
            if (this.defaultVaults.length == 0)
                this.defaultVaults = this.allVaults;
            //
            //
            if (value == "all tokens") {
                this.allVaults = this.defaultVaults;
            } else {
                this.allVaults = this.defaultVaults.filter(
                    a => this.fetchKey(key, a) == value
                );
            }
            this.sorting(
                this.activeSort.name,
                this.activeSort.key,
                this.activeSort.sort
            );
            this.tokenText = value;
        }
    },
    async mounted() {
        let chainId = this.chainId
            ? this.chainId
            : localStorage.getItem("chainId");
        await this.initToken();
        this.getAllVaults(chainId).then(result => {
            this.filtering("vault_token.symbol", "all tokens");
        });

        // if (!this.hasWallet) await this.connectWithMetamask();
    }
};
</script>

<style lang="scss">
@import "./resources/sass/app.scss";

.vault-page {
    position: relative;
    height: 100%;
    max-width: 69vw !important;
    padding: 0;
    margin-top: 1.9rem;
    z-index: 10;

    .mob-img {
        width: 2.153vw;
        height: 2.084vw;
    }
    .view-mode {
        display: flex;
        z-index: 10;
    }
    .view-mode-item {
        margin: auto 5px;
        cursor: pointer;
    }
    .filter-box {
        display: flex;
    }

    .title {
        text-align: center;
        font-family: "Exo";
        font-style: normal;
        font-weight: bold;
        font-size: 1.25vmax;
        line-height: 1.4vmax;
        text-shadow: 1px 1px 6px rgba(76, 212, 241, 0.25);
        background: $gradient-1;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 2.1vw;
    }
    .feature-fault {
        justify-content: normal !important;
    }

    @media only screen and (min-width: 768px) {
        #filter-wrapper {
            margin-left: 0 !important;

            .dropdown-filter-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;

                .dropdown.my-dropdown {
                    &:first-child {
                        @media only screen and (min-width: 992px) {
                            margin-right: 0.5555555555555556vw !important; // 8px in 1440px
                        }
                    }
                }

                @media only screen and (min-width: 768px) {
                    flex-direction: row;
                }
            }
        }
    }
}
.bottom-leafs {
    background: url("/images/Bottom-Leaves-new.png") no-repeat center bottom;
    position: fixed;
    background-size: cover;
    width: 100%;
    opacity: 0.2;
    min-height: 100%;
    bottom: 0;
    width: 100vw;
    height: calc(49vw / 1);
    min-height: 61%;
    z-index: 0;
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .vault-page {
        max-width: 100% !important;
        padding: 0 20px;
        margin-top: 1.7rem;
        .mob-img {
            width: 25px;
            height: 25px;
        }
        .title {
            font-size: 14px;
            line-height: 19px;
            margin-bottom: 20px;
        }
        .my-dropdown {
            .btn,
            .dropdown-menu {
                font-size: 12px;
                line-height: 16px !important;

                &.btn {
                    padding: 4px 25px !important;
                }
                > div {
                    max-height: 50vh;
                    overflow-y: auto;
                    padding: 4px 25px !important;
                }
            }
        }
    }
}
@media screen and (min-width: 1300px) {
    .vault-page {
        .my-dropdown {
            .btn,
            .dropdown-menu {
                > div {
                    max-height: 50vh;
                    overflow-y: auto;
                    padding: 4px 25px !important;
                }
            }
        }
    }
}
.dropdown-menu {
    z-index: 999 !important;
}

.dropdown-filter-wrapper {
    display: flex;

    .dropdown {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
}
</style>
